// extracted by mini-css-extract-plugin
module.exports = {"container":"Legend_container__pda7c","title":"Legend_title__12-if","item":"Legend_item__2YX7L","color":"Legend_color__dNo3d","name":"Legend_name__1P8sq"};